import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface ChartPrice {
  date: string;
  close: number;
}

interface AssetChartData {
  ticker: string;
  prices: ChartPrice[];
}

export function useAssetChart(ticker: string | null, range: string) {
  return useQuery<AssetChartData>({
    queryKey: ["asset-chart", ticker, range],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("asset-chart", {
        body: { ticker, range },
      });
      if (error) throw error;
      return data as AssetChartData;
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!ticker,
  });
}
